import { I18n, Store } from '../../wrappers';
import { ReportTypeLabel } from '../../types';
import { Printable } from '../../print';
import { dateFormatter } from '../../utilities/dateFormatter';
import Shift from '../Shift';
const { formatDate } = dateFormatter();
export class ReportLocalizationMe {
    report;
    constructor(client) {
        this.report = client;
    }
    static types(options = {}) {
        const { admin = false, isOnline: isOnlineOption, isRetail: isRetailOption, integrations: integrationsOption, modules: modulesOption } = options;
        const isRetail = isRetailOption ?? Store.get('isRetail');
        const isOnline = isOnlineOption ?? Store.get('isOnline');
        const integrations = integrationsOption ?? Store.get('integrations') ?? {};
        const modules = modulesOption ?? Store.get('modules') ?? {};
        return [
            {
                type: ReportTypeLabel.current_state,
                processMode: 'fiscal',
                category: I18n.t('reports.category.fiscal'),
                name: I18n.t('reports.current_state'),
                timeOptions: ['today'],
                enabled: true,
                fetchData: true,
                shared: true
            },
            {
                type: ReportTypeLabel.daily_report,
                processMode: 'fiscal',
                category: I18n.t('reports.category.fiscal'),
                name: I18n.t('reports.daily_report'),
                timeOptions: ['yesterday', 'byDate'],
                enabled: true,
                fetchData: true,
                shared: true
            },
            {
                type: ReportTypeLabel.periodic_report,
                processMode: 'fiscal',
                category: I18n.t('reports.category.fiscal'),
                name: I18n.t('reports.periodic_report'),
                timeOptions: ['today', 'yesterday', 'byDate'],
                enabled: true,
                fetchData: true,
                shared: true
            },
            {
                type: ReportTypeLabel.shift_report,
                processMode: 'fiscal',
                category: I18n.t('reports.category.fiscal'),
                name: I18n.t('reports.shift_report'),
                timeOptions: ['shift'],
                // Any recent shift can be picked online (the admin is always online); offline only the open one.
                enabled: admin || !!isOnline || !!Shift.current(),
                fetchData: true,
                shared: true
            },
            {
                type: ReportTypeLabel.sales_by_user_detailed,
                processMode: 'sales',
                category: I18n.t('reports.category.sales'),
                name: I18n.t('reports.sales_by_user_detailed'),
                timeOptions: ['shift'],
                enabled: !admin,
                fetchData: false,
                shared: false
            },
            {
                type: ReportTypeLabel.total_sales,
                processMode: 'sales',
                category: I18n.t('reports.category.sales'),
                name: I18n.t('reports.total_sales'),
                timeOptions: ['today', 'yesterday', 'byDate'],
                enabled: true,
                fetchData: true,
                shared: true
            },
            {
                type: ReportTypeLabel.sales_by_client,
                processMode: 'sales',
                category: I18n.t('reports.category.sales'),
                name: I18n.t('reports.sales_by_client'),
                timeOptions: ['today', 'yesterday', 'byDate'],
                enabled: true,
                fetchData: true,
                shared: true
            },
            {
                type: ReportTypeLabel.sales_by_user,
                processMode: 'sales',
                category: I18n.t('reports.category.sales'),
                name: I18n.t('reports.sales_by_user'),
                timeOptions: ['today', 'yesterday', 'byDate'],
                enabled: isOnline,
                fetchData: true,
                shared: false
            },
            {
                type: ReportTypeLabel.sales_by_product,
                processMode: 'sales',
                category: I18n.t('reports.category.sales'),
                name: I18n.t('reports.sales_by_product'),
                timeOptions: ['today', 'yesterday', 'byDate'],
                enabled: isOnline,
                fetchData: true,
                shared: true
            },
            {
                type: ReportTypeLabel.sales_by_product_category,
                processMode: 'sales',
                category: I18n.t('reports.category.sales'),
                name: I18n.t('reports.sales_by_product_category'),
                timeOptions: ['today', 'yesterday', 'byDate'],
                enabled: true,
                fetchData: true,
                shared: true
            },
            {
                type: ReportTypeLabel.sales_by_product_type,
                processMode: 'sales',
                category: I18n.t('reports.category.sales'),
                name: I18n.t('reports.sales_by_product_type'),
                timeOptions: ['today', 'yesterday', 'byDate'],
                enabled: !isRetail,
                fetchData: true,
                shared: true
            },
            {
                type: ReportTypeLabel.sales_by_product_type_sent_to_room,
                processMode: 'sales',
                category: I18n.t('reports.category.sales'),
                name: I18n.t('reports.sales_by_product_type_sent_to_room'),
                timeOptions: ['today', 'yesterday', 'byDate'],
                enabled: !isRetail && integrations.ota_sync,
                fetchData: true,
                shared: false
            },
            {
                type: ReportTypeLabel.sales_by_product_type_and_taxes,
                processMode: 'sales',
                category: I18n.t('reports.category.sales'),
                name: I18n.t('reports.sales_by_product_type_and_taxes'),
                timeOptions: ['today', 'yesterday', 'byDate'],
                enabled: !isRetail,
                fetchData: true,
                shared: true
            },
            {
                type: ReportTypeLabel.sales_by_sector,
                processMode: 'sales',
                category: I18n.t('reports.category.sales'),
                name: I18n.t('reports.sales_by_sector'),
                timeOptions: ['today', 'yesterday', 'byDate'],
                enabled: isOnline && !isRetail,
                fetchData: true,
                shared: false
            },
            {
                type: ReportTypeLabel.sales_by_table,
                processMode: 'sales',
                category: I18n.t('reports.category.sales'),
                name: I18n.t('reports.sales_by_table'),
                timeOptions: ['today', 'yesterday', 'byDate'],
                enabled: isOnline && !isRetail,
                fetchData: true,
                shared: false
            },
            {
                type: ReportTypeLabel.sales_by_ingredient,
                processMode: 'sales',
                category: I18n.t('reports.category.sales'),
                name: I18n.t('reports.sales_by_ingredient'),
                timeOptions: ['today', 'yesterday', 'byDate'],
                enabled: !!modules.product_ingredients && isOnline && !isRetail,
                fetchData: true,
                shared: false
            },
            {
                type: ReportTypeLabel.electronic_journal,
                processMode: 'journal',
                category: I18n.t('reports.category.journal'),
                name: I18n.t('reports.electronic_journal'),
                timeOptions: ['today', 'yesterday', 'byDate'],
                enabled: true,
                fetchData: true,
                shared: false
            },
            {
                type: ReportTypeLabel.offline_electronic_journal,
                processMode: 'journal',
                category: I18n.t('reports.category.journal'),
                name: I18n.t('reports.offline_electronic_journal'),
                timeOptions: ['today', 'yesterday', 'byDate'],
                enabled: true,
                fetchData: false,
                shared: false
            },
            {
                type: ReportTypeLabel.corrective_electronic_journal,
                processMode: 'journal',
                category: I18n.t('reports.category.journal'),
                name: I18n.t('reports.corrective_electronic_journal'),
                timeOptions: ['today', 'yesterday', 'byDate'],
                enabled: true,
                fetchData: true,
                shared: false
            },
            {
                type: ReportTypeLabel.product_quantities,
                processMode: 'default',
                category: I18n.t('reports.category.other'),
                name: I18n.t('reports.product_quantities'),
                timeOptions: [],
                enabled: true,
                fetchData: true,
                shared: false
            }
        ];
    }
    getAdditionalFooterPrintable(reportData) {
        const pr = new Printable();
        if ((!reportData.business_day_number && !reportData.first_business_day) && !reportData.first_order_number)
            return pr;
        if (reportData.business_day_number) {
            pr.l('S', `${I18n.t('reports.body.footer.business_day_number')}:`, `${reportData.business_day_number}`);
        }
        if (reportData.first_business_day) {
            pr.l('S', `${I18n.t('reports.body.footer.business_day_numbers')}:`, `${reportData.first_business_day} - ${reportData.last_business_day}`);
        }
        if (reportData.first_order_number) {
            pr.l('S', `${I18n.t('reports.body.footer.receipt_numbers')}:`, `${reportData.first_order_number} - ${reportData.last_order_number}`);
        }
        pr.l('D', '', { delimiter: '-' });
        return pr;
    }
    getFooterPrintable(reportData) {
        const pr = new Printable();
        pr.l('L', `${I18n.t('reports.body.footer.date')}: ${formatDate(reportData.date)}`);
        pr.l('L', `${I18n.t('reports.body.footer.time')}: ${reportData.time}`);
        pr.l('L', `${I18n.t('reports.body.footer.operator_code')}: ${reportData.operator_code}`);
        return pr;
    }
    getCashCalculationPrintable(reportData) {
        const pr = new Printable();
        const noncashOnly = !!this.report.getVenue()?.settings?.noncash_only;
        const einvoiceReport = reportData.type === 'einvoice_report';
        if (!reportData.cash_calculation || noncashOnly || einvoiceReport)
            return pr;
        pr.l('S', `${I18n.t('reports.body.cash_calculation.total_cash')}:`, reportData.cash_calculation.total_cash);
        pr.l('S', `${I18n.t('reports.body.cash_calculation.deposit')}:`, reportData.cash_calculation.total_deposits);
        pr.l('S', `${I18n.t('reports.body.cash_calculation.total_withdraws')}:`, reportData.cash_calculation.total_withdraws);
        pr.l('S', `${I18n.t('reports.body.cash_calculation.cash_sales_banknotes')}:`, reportData.cash_calculation.cash_sales_banknotes);
        pr.l('S', `${I18n.t('reports.body.cash_calculation.cash_sales_wo_banknotes')}:`, reportData.cash_calculation.cash_sales_wo_banknotes);
        pr.l('S', `${I18n.t('reports.body.cash_calculation.non_cash_sales')}:`, reportData.cash_calculation.non_cash_sales);
        pr.l('S', `${I18n.t('reports.body.cash_calculation.total_sales')}:`, reportData.cash_calculation.total_sales);
        pr.l('D', '', { delimiter: '-' });
        return pr;
    }
    getPaymentTypes(reportData) {
        const noncashOnly = !!this.report.getVenue()?.settings?.noncash_only;
        const cashEnabled = !noncashOnly;
        return {
            cash: [
                { type: 'banknote', enabled: cashEnabled },
                { type: 'card', enabled: cashEnabled },
                { type: 'order', enabled: cashEnabled },
                { type: 'other_cash', enabled: cashEnabled },
                { type: 'tip', enabled: cashEnabled },
            ],
            noncash: [
                { type: 'account', enabled: true },
                { type: 'business_card', enabled: true },
                { type: 'company', enabled: true },
                { type: 'order', enabled: true },
                { type: 'factoring', enabled: true },
                { type: 'advance', enabled: true },
                { type: 'voucher', enabled: true },
            ]
        };
    }
}
const ReportLocalizationMeStatic = ReportLocalizationMe;
//# sourceMappingURL=ReportLocalizationMe.js.map